import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UtilService } from '../../../services/util.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../../constants/constants';
import { ParametrizacionService } from '../../../services/parametrizacion.service';
import { MiddlewareService } from '../../../services/middleware.service';
import { EntidadService } from '../../../services/entidad.service';
import { EntidadDto } from '../../../dto/entidad/entidad.dto';

@Component({
  selector: 'app-nav-user',
  templateUrl: './nav-user.component.html',
  styleUrl: './nav-user.component.scss',
})
export class NavUserComponent implements OnInit, OnDestroy {
  public showAlertas = true;
  public showComponent = false;
  public tipoAlerta = '';
  //public isDetalleExpediente = false;
  //public isUrlTramite = false;
  public idExpediente?: number;
  public urlPqrs = '';
  public countAlertas = 0;
  beforeNav: (op: () => void) => Promise<void> | void = op => {
    op();
  };

  // Información de la pantalla y guía interactiva
  info!: InfoPantallaDTO;

  // Multilenguaje
  tableText: any = {};
  ruta: string = '';

  entidadJustifacil: EntidadDto = {
    id: 0,
    entidad: '',
  };

  userType: {
    Id: number | null;
    Nombre: string | null;
    Id_Entidad: number | null;
    selected?: boolean;
  } = {
      Id: null,
      Nombre: null,
      Id_Entidad: null,
    };
  // Tooltip
  tooltipVisible: string | null = null;
  constructor(
    private location: Location,
    private utilService: UtilService,
    private router: Router,
    private alertService: AlertaModalService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
    private middlewareService: MiddlewareService,
    private parametrizacionService: ParametrizacionService,
    private entidadService: EntidadService,
  ) {
    this.entidadService.obtenerEntidadJustifacil().subscribe(response => {
      this.entidadJustifacil = response;
    });
    // Multilenguaje
    this.translate.stream('nav-user').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
    });

    this.userType = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
  }

  ngOnInit(): void {
    this.utilService.watch().subscribe(val => {
      this.showAlertas = val;
    });
    this.utilService.watchNavUser().subscribe(val => {
      this.showComponent = val;
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.utilService.changeInfoPantalla({
          descripcionPantalla: '',
          pasos: [],
          tituloPantalla: '',
        });
      }
      if (event instanceof NavigationEnd) {
        // console.log(event.url)
        this.ruta = event.url;
        if (/^\/tramites$/.test(event.url)) {
          this.tipoAlerta = 'tramites';
        } else if (/^\/expediente\/\w+\/\d+$/.test(event.url)) {
          this.tipoAlerta = 'expediente';
          this.idExpediente = +(event.url?.split('/').pop() ?? '');
        } else {
          this.tipoAlerta = 'general';
        }
        if (!event.url.includes('glosario-entidad')) {
          this.utilService.setIdEntidad(0);
        }
      }
      // console.log(this.ruta.split('/')[1]);

      // console.log("alertas", this.tipoAlerta);
    });
    // Información de la pantalla y guía interactiva
    this.utilService.watchInfoPantalla().subscribe((info: InfoPantallaDTO) => {
      if (info) {
        this.info = info;
        this.cd.detectChanges();
      }
    });
  }

  async goBack() {
    if (this.info.change) {
      await this.info.change(() => {
        this.location.back();
      });
    } else {
      const infoInicioSesion = JSON.parse(
        sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
      );
      if (
        infoInicioSesion.Nombre == 'Superadministrador' ||
        infoInicioSesion.Nombre.includes('Administrador')
      ) {
        this.location.back();
      } else {
        if (this.ruta.split('/')[1] == 'justino') {
          this.middlewareService.triggerShowReviewAction();
        } else {
          this.location.back();
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.utilService.show();
  }

  // Función que inicia la guí interactiva
  comenzarGuia() {
    this.utilService.iniciarGuiaInteractiva();
  }

  // Función que direcciona al componente de preguntas frecuentes
  async cargarPreguntas() {
    await this.router.navigateByUrl('/preguntas-frecuentes');
  }

  private obtenerUrlPqrs(): void {
    this.parametrizacionService.obtenerParametrizacionUrlPqrs().subscribe({
      next: data => {
        if (data?.valor_parametro) {
          this.urlPqrs = data.valor_parametro;
        } else {
          console.error('No se encontró la URL en valor_parametro');
        }
      },
      error: err => {
        console.error('Error obteniendo la parametrización:', err);
      },
    });
  }

  async cargarModal() {
    this.obtenerUrlPqrs();
    await this.alertService.confirmacion(
      this.tableText['tener-en-cuenta'],
      this.tableText['bienvenido'] + this.entidadJustifacil.entidad,
      () => {
        window.open(this.urlPqrs, '_blank');
      },
      () => { }
    );
  }

  mostrarTooltip(tooltipId: string): void {
    this.tooltipVisible = tooltipId;
  }

  ocultarTooltip(): void {
    this.tooltipVisible = null;
  }
}
